<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="纳税人识别号" min-width="180" >
            <template slot-scope="scope">
              {{ scope.row.taxpayer_identify_number }}
            </template>
        </el-table-column>
        <el-table-column label="主管机关名称">
            <template slot-scope="scope">
              {{ scope.row.satrap_department_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="信用评级">
            <template slot-scope="scope">
              {{ scope.row.credit_ratings || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="评级年份">
            <template slot-scope="scope">
              {{ scope.row.ratings_year || '-' }}
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'taxCreditRating',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '纳税信用等级',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>